import safeLocalStorage from '../helpers/safeLocalStorage';

export const LANGUAGE_POPUP_STORAGE_KEY = 'language-popup-hidden';

const isLanguagePopupHidden = () => {
  return (
    safeLocalStorage.getItem(LANGUAGE_POPUP_STORAGE_KEY) || window.currentLanguage === 'uk'
  );
};

export default isLanguagePopupHidden;
